import { useQuery } from '@tanstack/react-query';
import CompanyService from '@/services/company-service';

const LS_PREFIX = 'cz_co_';

function lsRead(t: any, c: any) {
  try {
    const raw = localStorage.getItem(`${LS_PREFIX}${t}_${c}`);
    return raw ? JSON.parse(raw) : undefined;
  } catch { return undefined; }
}

function lsWrite(t: any, c: any, data: any) {
  try {
    localStorage.setItem(`${LS_PREFIX}${t}_${c}`, JSON.stringify(data));
  } catch {}
}

export function useCustomerZoneCompany(t: any, c: any, api: any) {
  const cached = lsRead(t, c);
  return useQuery(
    ['czCompany', t, c],
    async () => {
      const data = await CompanyService.getCustomerZoneCompany(t, c, api);
      if (data?.LogoUrl) lsWrite(t, c, data);
      return data;
    },
    {
      enabled: !!api,
      initialData: cached ?? undefined,
      staleTime: cached?.LogoUrl ? 30 * 60 * 1000 : 0,
    }
  );
}
